import React, { useCallback } from 'react'

import { Column, Loader } from 'Components/UI'

import { HubSpotFormId } from 'Constants/HubSpot'

import { useHubSpotFormLoader } from 'Hooks'

import { Container } from './styles'

type Props = { onSubmit?: () => void }

function JoinUsTodayForm({ onSubmit }: Props) {
  const handleFormSubmitted = useCallback(() => onSubmit?.(), [onSubmit])

  const { ref, loading } = useHubSpotFormLoader({
    formId: HubSpotFormId.GetInTouch,
    onFormSubmitted: handleFormSubmitted,
  })

  return (
    <Column minHeight={602}>
      {loading && (
        <Column alignCenter grow justifyCenter>
          <Loader />
        </Column>
      )}

      <Container id={HubSpotFormId.GetInTouch} ref={ref} />
    </Column>
  )
}

export default JoinUsTodayForm
